<template>
  <with-actions v-if="userGroup">
    <div class="card">
      <div class="card-body">
        <h2 class="mx-2 my-3">
          <span v-if="userGroup.visible">{{ 'local_user_template' | t }}</span
          ><span v-else>{{ 'admin_right' | t }}</span>
        </h2>
        <div class="form-group">
          <label>{{ 'name' | t }}</label>
          <input class="form-control form-control-lg" v-model="userGroup.name" />
        </div>
        <table class="table table-hover">
          <thead>
            <tr>
              <th></th>
              <th class="text-center">{{ 'scope_permission' | t }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in mappedScopes">
              <td>
                <label>{{ key | t }}</label>
              </td>
              <td class="text-center">
                <select class="form-control" v-model="scopes[key]">
                  <option value="none">{{ 'permission_none' | t }}</option>
                  <option value="read">{{ 'permission_read' | t }}</option>
                  <option value="write">{{ 'permission_write_and_read' | t }}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row" v-if="can('write_user_groups')">
          <div class="col">
            <div class="btn btn-lg btn-danger" @click="deleteUserGroup">{{ 'delete' | t }}</div>
          </div>
          <div class="col text-right">
            <div class="btn btn-lg btn-primary" @click="updateUserGroup">{{ 'update' | t }}</div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import config from '@/config';
import Alerts from '@/utils/alerts';
import $ from 'jquery';

export default {
  props: {
    user_group_id: String,
    is_staff: String
  },
  data: function () {
    return {
      userGroup: {},
      scopes: {},
      mappedScopes: {},
      mappedUserGroupScopes: {}
    };
  },
  created() {
    Api.find('user_groups', this.user_group_id).then((response) => {
      this.userGroup = response.data;
      this.mappedScopes = this.mapScopes(config.scopes);
      this.mappedUserGroupScopes = this.mapScopes(this.userGroup.scopes.split(' '));
      this.modelScopes(this.mappedScopes);
    });
  },
  methods: {
    /**
     *
     * @param event {MouseEvent}
     * @returns {Promise<never>}
     */
    async updateUserGroup(event) {
      if (event.target) {
        $(event.target).loading();
      }
      if (!this.userGroup.visible) {
        this.userGroup.scopes = 'admin';
      } else {
        this.userGroup.scopes = '';
      }

      for (const prop in this.scopes) {
        if (this.scopes[prop] === 'write') {
          let write_scope = `write_${prop}`;
          if (config.scopes.includes(write_scope)) this.userGroup.scopes += ` ${write_scope}`;
        }

        if (this.scopes[prop] === 'read' || this.scopes[prop] === 'write') {
          let read_scope = `read_${prop}`;
          if (config.scopes.includes(read_scope)) this.userGroup.scopes += ` ${read_scope}`;
        }
      }

      try {
        await Api.update('user_groups', _.omit(this.userGroup, 'users'));
      } catch (e) {
        Alerts.danger({ title: 'Unable to update group', detail: '' });
        return Promise.reject(new Error(400));
      }

      Alerts.success({ title: 'Group updated', detail: '' });
      if (event.target) {
        $(event.target).loading(false);
      }
    },
    /**
     *
     * @param event {MouseEvent}
     * @returns {Promise<void>}
     */
    async deleteUserGroup(event) {
      if (event.target) {
        $(event.target).loading();
      }

      if (!confirm('Will you delete this group?')) {
        if (event.target) {
          $(event.target).loading(false);
        }
        return;
      }

      try {
        await Api.destroy('user_groups', this.userGroup.id);
      } catch (e) {
        Alerts.danger({ title: 'Unable to delete group', detail: '' });
      }

      this.$router.push({ name: 'user_groups' });
      Alerts.info({ title: 'Group deleted', detail: '' });
    },
    /**
     *
     * @param scopes {string[]}
     * @returns {Object}
     */
    mapScopes(scopes) {
      let mapped = {};
      scopes.forEach((scope) => {
        const scopeArray = scope.match(/(read|write)_(.*)/);
        if (scopeArray === null || scopeArray.length !== 3) {
          return;
        }

        if (!mapped.hasOwnProperty(scopeArray[2])) {
          mapped[scopeArray[2]] = {};
        }

        mapped[scopeArray[2]][scopeArray[1]] = true;
      });

      return mapped;
    },
    /**
     *
     * @param scopes {string[]}
     */
    modelScopes(scopes) {
      for (const prop in scopes) {
        if (!this.mappedUserGroupScopes.hasOwnProperty(prop)) {
          this.scopes[prop] = 'none';
          continue;
        }

        if (this.mappedUserGroupScopes[prop].write) {
          this.scopes[prop] = 'write';
          continue;
        }

        if (this.mappedUserGroupScopes[prop].read) {
          this.scopes[prop] = 'read';
          continue;
        }

        this.scopes[prop] = 'none';
      }
    }
  }
};
</script>
